import MainBlob from "../../../animate/MainBlob";
import style from "./EntryBlock.module.scss";
import CoinsIcon from "../../../../public/workspace/coins_stack.svg";
import { useStore } from "../../../../stores/use_global_state.js";
import { addToLocalStorage } from "../../../../utils/nonAuthLocalStorage";

function EntryBlock({ dictionary, uploadFile, openAuthModal = () => {} }) {
	const { state } = useStore();

	const nonAuthHandler = () => {
		if (state.isAuth) return;
		addToLocalStorage("removeBg");
		openAuthModal();
	};

	const title = dictionary["page_removebg_title"] || "Remove video background";
	const description = dictionary["page_removebg_description"] || "100% automatically with AI, no green screen required.";

	const inputOnChange = ({ target }) => uploadFile(target.files);
	const accept = ".mp4,.mov, .mkv, video/mp4, .webm, .jpg, .jpeg, .png, image/png, image/jpeg";

	return (
		<section className={style.section}>
			<div className={style.info}>
				<h1 className={style.title}>{title}</h1>
				<p className={style.description}>{description}</p>
				<label className={style.label} htmlFor="video_file" id="file-label" onClick={nonAuthHandler}>
					<input disabled={!state.isAuth} className={style.input} onChange={inputOnChange} type="file" name="" id="video_file" accept={accept} />
					{dictionary["Upload file"]}
				</label>
				<span className={style.creditsInfo}>
					<CoinsIcon className={style.coinIcon} /> {dictionary["1_sec_4_credits"].replace("4", "1") || "1 second = 1 credits"}
				</span>
			</div>
			<video className={style.video} autoPlay loop muted playsInline preload="true" poster="/video/remove_bg_preview.jpg">
				<source src="/video/remove_bg_video.mp4" type="video/mp4" />
			</video>
			<MainBlob />
		</section>
	);
}

export default EntryBlock;
